import { render, staticRenderFns } from "./cellcomb.vue?vue&type=template&id=1f6b4be8&"
import script from "./cellcomb.vue?vue&type=script&lang=js&"
export * from "./cellcomb.vue?vue&type=script&lang=js&"
import style0 from "./cellcomb.vue?vue&type=style&index=0&id=1f6b4be8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports